import { assert } from "@/core";
import { BaseService } from "./base.service";
import { ResponseWrapper } from "./util";

export class HospitalsService extends BaseService {
  static get entity() {
    return "hospitals";
  }

  static async getList(parameters = {}) {
    assert.object(parameters);

    const params = { ...parameters };

    const response = await this.request({ auth: true }).get(
      `healthcare/${this.entity}/names`,
      { params }
    );
    return new ResponseWrapper(response, response.data.data);
  }

  static async update(id, data = {}) {
    assert.string(id, { required: true });
    assert.object(data, { required: true });

    const response = await this.request({ auth: true }).patch(
      `healthcare/${this.entity}/${id}`,
      data
    );
    return new ResponseWrapper(response, response.data.data);
  }
}
